import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navigationItems } from "../utils/utils";

const Sidebar = ({ isOpen, onClose }) => {
  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isOpen) {
      // Only prevent scrolling on small screens (mobile devices)
      if (window.innerWidth <= 900) {
        document.body.classList.add("no-scroll");
      }
      setTimeout(() => setShow(true), 10);
    } else {
      setShow(false);
      // Remove the no-scroll class when sidebar closes
      document.body.classList.remove("no-scroll");
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  // Handle window resize to update scroll behavior
  useEffect(() => {
    const handleResize = () => {
      if (isOpen) {
        if (window.innerWidth <= 900) {
          document.body.classList.add("no-scroll");
        } else {
          document.body.classList.remove("no-scroll");
        }
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen]);

  // Function to check if a nav item is active
  const isActive = (item) => {
    if (item.isHome) {
      return location.pathname === "/";
    }
    if (item.category) {
      // Handle URL encoding for Albanian characters
      const decodedPathname = decodeURIComponent(location.pathname);
      const isActivePath =
        decodedPathname === item.path ||
        decodedPathname.includes(`/category/${item.category}`);
      return isActivePath;
    }
    return location.pathname === item.path;
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        className={`sidebar-overlay ${show ? "show" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      ></div>
      <nav
        className={`sidebar ${show ? "slide-in" : ""}`}
        aria-label="Main navigation"
      >
        <button
          onClick={onClose}
          className="close-btn"
          aria-label="Mbyll menunë"
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <ul className="nav-list sidebar-container">
          {navigationItems.map((item) => (
            <li key={item.id}>
              <Link
                to={item.path}
                onClick={onClose}
                className={
                  isActive(item) ? "sidebar-link active" : "sidebar-link"
                }
              >
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
